'use client'

import { ArticleSubcategory } from '@/types/api/article-category'
import s from './subcategory-articles.module.css'
import { Article } from '@/types/Article'
import { LoadMoreArticles } from '@/components/v3/organisms/load-more-articles/load-more-articles'
import { CATEGORY_PAGE } from '@/constants'
import { SubcategoryChipSlider } from '@/components/v3/molecules/subcategory-chip-slider/subcategory-chip-slider'
import { SectionContainerV3 } from '@/components/v3/atoms/section-container/section-container'
import { CATEGORY_PAGE_ADS } from '@/constants/ads-slots'
import { usePathname } from 'next/navigation'
import { GoogleAdClient } from '@/components/v3/atoms/google-ad-client/google-ad-client'
import { getAdObjectByKey } from '@/utils/getAdObjectByKey'
import { mapApiArticleToPrisma } from '@/utils/mapApiToPrisma'

type Props = {
  subcategories: ArticleSubcategory[]
  selectedSubcategory: ArticleSubcategory
  filteredArticles: Article[]
  articlesByAllHasMore: boolean
  cardHeadingLevel?: 'h2' | 'h3' | 'h4'
}

export const SubcategoryArticles = ({
  subcategories,
  selectedSubcategory,
  filteredArticles,
  articlesByAllHasMore,
  cardHeadingLevel,
}: Props) => {
  return (
    <>
      <SectionContainerV3>
        <h2 className={s.header}>Latest</h2>
      </SectionContainerV3>

      <SectionContainerV3
        innerProps={{
          className: s.subcategorySliderInnerContainer,
        }}
      >
        <SubcategoryChipSlider
          selectedSubcategory={selectedSubcategory}
          subcategories={subcategories}
        />
      </SectionContainerV3>

      <SectionContainerV3 className={s.articlesContainer}>
        {selectedSubcategory.name === CATEGORY_PAGE.viewAllArticlesName ? (
          <LoadMoreArticles
            articles={mapApiArticleToPrisma(filteredArticles)}
            hasMoreArticles={articlesByAllHasMore}
            googleAd={<GoogleAd />}
            headingLevel={cardHeadingLevel}
          />
        ) : (
          <LoadMoreArticles
            articles={mapApiArticleToPrisma(filteredArticles)}
            exploreMore
            googleAd={<GoogleAd />}
            headingLevel={cardHeadingLevel}
          />
        )}
      </SectionContainerV3>
    </>
  )
}

const GoogleAd = () => {
  const pathname = usePathname()
  const adObject = getAdObjectByKey(pathname, CATEGORY_PAGE_ADS)

  if (!adObject) {
    return null
  }

  return (
    <GoogleAdClient
      mobileAd={{
        ...adObject.mobile.bottomAd,
        divProps: {
          style: {
            width: `${adObject.mobile.bottomAd.size[0]}px`,
            height: `${adObject.mobile.bottomAd.size[1]}px`,
          },
        },
      }}
      desktopAd={{
        ...adObject.desktop.bottomAd,
        divProps: {
          style: {
            width: `${adObject.desktop.bottomAd.size[0]}px`,
            height: `${adObject.desktop.bottomAd.size[1]}px`,
          },
        },
      }}
    />
  )
}
